/* Semillas de calabaza · versión nueva. Funciona igual en la página externa y dentro de una sección de Shopify:
   todo se busca dentro de #cz y nada depende del tema. */
(function () {
  var raiz = document.getElementById('cz');
  if (!raiz || raiz.dataset.czListo) return;
  raiz.dataset.czListo = '1';
  var captura = /[?&]captura=1/.test(location.search);
  var reduce = captura || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (captura) raiz.classList.add('cz-captura');
  var $ = function (s) { return raiz.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(raiz.querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };

  /* --- cabecera fija del tema: la barra y las secciones pegadas quedan debajo --- */
  function medirCabecera() {
    var alto = 0;
    var cab = document.querySelector('sticky-header, header.header, .shopify-section-header-sticky, .section-header');
    if (cab) {
      var r = cab.getBoundingClientRect(), pos = getComputedStyle(cab).position;
      if ((pos === 'sticky' || pos === 'fixed') && r.top <= 0 && r.bottom > 0) alto = Math.round(r.bottom);
    }
    raiz.style.setProperty('--cz-top', alto + 'px');
  }

  /* --- 1 · semillas de calabaza que caen y saltan al tocar --- */
  var hero = $('#cz-hero'), lienzo = $('#cz-semillas');
  if (hero && lienzo && !reduce) {
    var ctx = lienzo.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), semillas = [], visible = true;
    var rnd = function (a, b) { return a + Math.random() * (b - a); };
    var medir = function () { lienzo.width = hero.clientWidth * dpr; lienzo.height = hero.clientHeight * dpr; };
    medir(); window.addEventListener('resize', medir);
    var nueva = function (arriba) {
      return { x: rnd(0, lienzo.width), y: arriba ? rnd(-60, -10) * dpr : rnd(0, lienzo.height * .5), r: rnd(6, 11) * dpr,
        vx: rnd(-.25, .25) * dpr, vy: rnd(.35, .8) * dpr, a: rnd(0, 6.3), va: rnd(-.03, .03), al: rnd(.55, .9) };
    };
    var N = window.innerWidth < 760 ? 14 : 24;
    for (var i = 0; i < N; i++) semillas.push(nueva(false));
    var semilla = function (s) {
      ctx.save(); ctx.translate(s.x, s.y); ctx.rotate(s.a); ctx.globalAlpha = s.al;
      ctx.beginPath(); ctx.ellipse(0, 0, s.r * .62, s.r, 0, 0, Math.PI * 2);
      var g = ctx.createLinearGradient(-s.r, 0, s.r, 0); g.addColorStop(0, '#C9DB8E'); g.addColorStop(.5, '#7E9C3F'); g.addColorStop(1, '#5B7A2C');
      ctx.fillStyle = g; ctx.fill(); ctx.lineWidth = 1.2 * dpr; ctx.strokeStyle = 'rgba(245,240,210,.85)'; ctx.stroke();
      ctx.beginPath(); ctx.ellipse(-s.r * .12, -s.r * .2, s.r * .14, s.r * .45, 0, 0, Math.PI * 2); ctx.fillStyle = 'rgba(255,255,255,.35)'; ctx.fill();
      ctx.restore();
    };
    hero.addEventListener('pointerdown', function (e) {
      var r = lienzo.getBoundingClientRect(), px = (e.clientX - r.left) * dpr, py = (e.clientY - r.top) * dpr;
      semillas.forEach(function (s) { var dx = s.x - px, dy = s.y - py, d = Math.hypot(dx, dy) || 1; if (d < 160 * dpr) { s.vx += dx / d * 4 * dpr; s.vy += dy / d * 4 * dpr - 2 * dpr; } });
      for (var k = 0; k < 6; k++) { var n = nueva(false); n.x = px; n.y = py; n.vx = rnd(-4, 4) * dpr; n.vy = rnd(-5, -1) * dpr; semillas.push(n); }
    }, { passive: true });
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(hero);
    (function cuadro() {
      requestAnimationFrame(cuadro);
      if (!visible) return;
      ctx.clearRect(0, 0, lienzo.width, lienzo.height);
      for (var j = semillas.length - 1; j >= 0; j--) {
        var s = semillas[j];
        s.vy = Math.min(s.vy + .02 * dpr, 1.2 * dpr); s.vx *= .985; s.x += s.vx; s.y += s.vy; s.a += s.va;
        if (s.y > lienzo.height + 30 * dpr) { if (semillas.length > N) semillas.splice(j, 1); else semillas[j] = nueva(true); continue; }
        semilla(s);
      }
    })();
  }

  /* --- progreso de una sección alta con contenido pegado --- */
  function progreso(sec) { var r = sec.getBoundingClientRect(); return clamp(-r.top / Math.max(1, r.height - window.innerHeight), 0, 1); }

  /* --- 3 · reloj: de las 3:00 a las 7:00 con el scroll --- */
  var reloj = $('#cz-reloj'), hora = $('#cz-hora'), veces = $('#cz-veces'), etiqueta = $('#cz-reloj-etiqueta'), pasos = $$('.cz-paso'), ultimasVeces = '3';
  function pintarReloj() {
    if (!reloj) return;
    var p = reduce ? 1 : progreso(reloj);
    reloj.style.setProperty('--p', p.toFixed(3));
    var min = Math.round((180 + p * 240) / 5) * 5, h = Math.floor(min / 60), m = min % 60;
    hora.textContent = h + ':' + (m < 10 ? '0' : '') + m;
    var v = p < .38 ? '3' : p < .62 ? '2' : '1';
    if (v !== ultimasVeces) { veces.textContent = v; veces.classList.add('cz-pulso'); setTimeout(function () { veces.classList.remove('cz-pulso'); }, 300); ultimasVeces = v; }
    var activo = p < .34 ? 0 : p < .67 ? 1 : 2;
    pasos.forEach(function (el, i) { el.classList.toggle('cz-activo', i === activo); });
    reloj.classList.toggle('cz-amanece', p > .62);
    etiqueta.textContent = p > .62 ? 'Con tu rutina de 3 cápsulas' : 'Así son tus noches hoy';
  }

  /* --- 6 · las dos mitades se unen en una cápsula --- */
  var dos = $('#cz-dos-escena');
  function pintarDos() {
    if (!dos) return;
    var r = dos.getBoundingClientRect(), vh = window.innerHeight;
    var u = reduce ? 1 : clamp((vh * .92 - r.top) / (vh * .55), 0, 1);
    dos.style.setProperty('--u', u.toFixed(3));
  }

  /* --- 13 · botón fijo: aparece al salir del hero, se esconde en la oferta y el cierre --- */
  var fijo = $('#cz-fijo'), oferta = $('#cz-oferta'), cierre = $('#cz-cierre');
  function pintarFijo() {
    if (!fijo || !hero) return;
    var dentro = function (el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.top < innerHeight * .85 && r.bottom > innerHeight * .25; };
    var modal = document.getElementById('cz-modal');
    var ver = hero.getBoundingClientRect().bottom < 60 && !dentro(oferta) && !dentro(cierre) && !(modal && !modal.hidden);
    fijo.classList.toggle('cz-visible', ver); fijo.setAttribute('aria-hidden', String(!ver));
  }

  var pendiente = false;
  function alScroll() {
    if (pendiente) return; pendiente = true;
    requestAnimationFrame(function () { pendiente = false; pintarReloj(); pintarDos(); pintarFijo(); });
  }
  window.addEventListener('scroll', alScroll, { passive: true });
  window.addEventListener('resize', function () { medirCabecera(); alScroll(); });

  /* --- aparición y contadores --- */
  var io = new IntersectionObserver(function (en) {
    en.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('cz-visto'); io.unobserve(e.target);
      if (e.target.hasAttribute('data-contar')) {
        var fin = +e.target.getAttribute('data-contar'), t0 = performance.now(), dur = reduce ? 1 : 1100;
        (function paso(t) { var k = clamp((t - t0) / dur, 0, 1); e.target.textContent = Math.round(fin * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(paso); })(t0);
      }
    });
  }, { threshold: .2 });
  $$('.cz-aparece, [data-contar]').forEach(function (el) { io.observe(el); });

  /* --- 8 · para ella / para él --- */
  var selector = $('.cz-selector');
  $$('.cz-selector__btn').forEach(function (b) {
    b.addEventListener('click', function () {
      selector.setAttribute('data-quien', b.dataset.quien);
      $$('.cz-selector__btn').forEach(function (x) { x.classList.toggle('cz-activo', x === b); x.setAttribute('aria-selected', String(x === b)); });
      $$('.cz-quien').forEach(function (p) { p.classList.toggle('cz-activo', p.dataset.panel === b.dataset.quien); });
    });
  });

  /* --- 5 · videos: solo uno suena a la vez --- */
  var videos = $$('.cz-video video');
  videos.forEach(function (v) { v.addEventListener('play', function () { videos.forEach(function (o) { if (o !== v) o.pause(); }); }); });

  medirCabecera(); pintarReloj(); pintarDos(); pintarFijo();
  setTimeout(medirCabecera, 800);
})();
